import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'app-style-guide',
    templateUrl: './style-guide.component.html',
    styleUrls: ['./style-guide.component.scss'],
    standalone: false
})
export class StyleGuideComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
